module.exports = __webpack_public_path__ + "img/7-speelgoed.d8756b0e.jpg";